export const ADMIN_PERMS = [
  { key: "dashboard", label: "Dashboard", path: "/admin/dashboard" },
  { key: "sohbetler", label: "Sohbetler", path: "/admin/sohbetler" },
  { key: "tedarikciler", label: "Tedarikçiler", path: "/admin/kullanicilar" },
  { key: "davetler", label: "Davetler", path: "/admin/davetler" },
  { key: "musteriler", label: "Müşteriler", path: "/admin/musteriler" },
  { key: "projeler", label: "Projeler", path: "/admin/projeler" },
  { key: "teklifler", label: "Teklifler", path: "/admin/teklifler" },
  { key: "basvurular", label: "Başvurular", path: "/admin/basvurular" },
  { key: "referanslar", label: "Referanslar", path: "/admin/referanslar" },
  { key: "sss", label: "SSS", path: "/admin/sss" },
  { key: "kullanicilar", label: "Kullanıcı Yönetimi", path: "/admin/yoneticiler" },
];

export const permLabel = (key) => (key === "all" ? "Tam Yetkili" : ADMIN_PERMS.find((p) => p.key === key)?.label || key);

export const hasPerm = (user, perm) => {
  const perms = user?.permissions?.length ? user.permissions : ["all"];
  return perms.includes("all") || perms.includes(perm);
};

export const firstAllowedPath = (user) => {
  const found = ADMIN_PERMS.find((p) => hasPerm(user, p.key));
  return found ? found.path : "/login";
};
